import { fromEvent } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

export const getInputTyping = (element: HTMLInputElement) =>
  fromEvent(element, 'input').pipe(
    debounceTime(100),
    map(() => element.value),
    startWith('')
  );
